import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  name: string;
  picture: string;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  hasAccess: boolean;
  setUser: (user: User) => void;
  clearUser: () => void;
}

const ALLOWED_EMAILS = [
  'nishanth.codr@gmail.com',
  'nishanth.dte@gmail.com',
  'nishanth.chn@gmail.com',
  'diana.mohan@gmail.com',
];

const isEmailAllowed = (email: string): boolean => {
  return ALLOWED_EMAILS.includes(email.toLowerCase());
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      hasAccess: false,
      setUser: (user: User) => {
        const hasAccess = isEmailAllowed(user.email);
        set({ user, isAuthenticated: true, hasAccess });
      },
      clearUser: () => {
        set({ user: null, isAuthenticated: false, hasAccess: false });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
